import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { of } from "rxjs/internal/observable/of";
import { OnBoardingInfo, OnBoardingStepDetail } from "../../shared/models/onBoarding.model";
import { resolve, reject } from "q";

@Injectable({
  providedIn: "root"
})
export class OnBoardingStepService {

  constructor() { }

  public GetOnBoardingInfo(): Promise<OnBoardingInfo> {
    const onBoardingInfo = new OnBoardingInfo();
    const promise = new Promise<OnBoardingInfo>((resolve, reject) => {
      onBoardingInfo.type = 1;
      onBoardingInfo.repeatation = 3;
      onBoardingInfo.routeList = null;
      resolve(onBoardingInfo);
    });
    return promise;
  }

  public GetOnBoardingDetail(): Promise<OnBoardingStepDetail> {
    const onBoardingStepDetail = new OnBoardingStepDetail();
    // const promise = new Promise<OnBoardingStepDetail>((resolve, reject) => {
    //   onBoardingStepDetail.skipButton = "";
    //   onBoardingStepDetail.templateNames = ["onBoardingGreeting", "onBoardingPostalCode", "onBoardingBirthdate", "onBoardingGender", "onBoardingAllergy", "onBoardingPreference"];
    //   onBoardingStepDetail.StepDetailName = { title: "Moin Moin", description: "Verrate uns Deinen Vornemen und wir können besser miteiander" };
    //   onBoardingStepDetail.StepDetailPostal = { title: "Danke", description: "Das zeigen wir Dir natürlich gar nicht erst an." };
    //   onBoardingStepDetail.StepDetailBirthday = { title: "Geburstag", description: "" };
    //   onBoardingStepDetail.StepDetailGender = { title: "Geschlecht", description: "", genders: [{ value: 1, key: "Herr" }, { id: 2, name: "Frau" }] };
    //   onBoardingStepDetail.StepDetailAllergy = {
    //     title: "Allergien sind doof!"
    //     , description: "Verrate uns, was Du nicht vertrögst und du bekommst nur die Speisen, die es nicht beinhalten angeyeigt."
    //     , alergies: [{ id: 1, name: "Eiweiß", selected: false }, { id: 2, name: "Nüsse", selected: false }, { id: 3, name: "Gluten", selected: false }
    //       , { id: 4, name: "Laktose", selected: false }, { id: 5, name: "Soja", selected: false }, { id: 6, name: "Laktose", selected: false }, { id: 7, name: "Soja", selected: false }]
    //     , additives: [{ id: 1, name: "Pfeffer", selected: false }, { id: 2, name: "Knoblauch", selected: false }
    //       , { id: 2, name: "Gewürz", selected: false }, { id: 2, name: "Salz", selected: false }]
    //   };
    //   onBoardingStepDetail.StepDetailPrefences = {
    //     title: "Präferenzen"
    //     , description: ""
    //     , preferences: [{ id: 1, name: "Vegeterian", selected: false }, { id: 2, name: "Alkohol", selected: false }
    //       , { id: 3, name: "Vegan", selected: false }, { id: 4, name: "Salat", selected: false }]
    //   };
    //   resolve(onBoardingStepDetail);
    // });
    return Promise.resolve(onBoardingStepDetail);
  }
}
